import { FaEthereum } from 'react-icons/fa';
var Inflector = require('inflected');

const Chain = {
    Title: ({ chain }) => Inflector.humanize(chain),
    Logo: ({ chain }) => {
        chain = chain.replace("-test", "");
        return <img height="20" width="20" src={"/blockchain-logos/" + chain + ".png"} />;
    },
    Full: ({ chain }) => {
        let chainTitle
        if (chain.indexOf("-test") > -1) {
            chainTitle = Chain.Title({ chain: chain.replace("-test", "") }) + " (Testnet)"

        } else {
            chainTitle = Chain.Title({ chain })
        }
        return <span>{Chain.Logo({ chain })}  {chainTitle}</span>
    }
}
export default Chain;